import { FormlyFieldConfig } from '@ngx-formly/core';
import { IntlService } from '@progress/kendo-angular-intl';

export function fixKendoDateTime(model: any, properties: { [key: string]: FormlyFieldConfig; }) {
    const clone = { ...model };

    Object.entries(properties).forEach(([key, item]) => {
        if (item.type === 'date' || item.type === 'dateTime' || item.type === 'monthDate' || item.type === 'yearDate' ||
            item.type === 'datepicker' || item.type === 'datepickerTime' || item.type === 'monthDatepicker' || item.type === 'yearDatepicker') {

            const date = parseDateAsUTC(clone[key]);

            if (isDate(date)) {
                clone[key] = date;
            }
        }
    });

    return clone;
}

export function parseDate(json) {
    Object.keys(json).map((key) => {
        const date = new Date(json[key]);
        if (!isNaN(date.getTime())) {
            json[key] = date;
        }
    });

    return json;
}

export function parseDateExact(intl: IntlService, json) {
    Object.keys(json).map(key => {
        const date = intl.parseDate(json[key], 'yyyy-MM-ddTHH:mm:ss');
        if (date) { json[key] = date; }
    });

    return json;
}

const _localTimeRegex = /.\d{3}$/;
function classof(o: any) {
    if (o === null) {
        return "null";
    }
    if (o === undefined) {
        return "undefined";
    }
    return Object.prototype.toString.call(o).slice(8, -1).toLowerCase();
}

export function isDate(o: any) {
    return classof(o) === "date" && !isNaN(o.getTime());
}

export function parseDateAsUTC(source: any) {
    if (typeof source === 'string') {
        // convert to UTC string if no time zone specifier.
        let isLocalTime = _localTimeRegex.test(source);
        // var isLocalTime = !hasTimeZone(source);
        source = isLocalTime ? source + 'Z' : source;
    }
    source = new Date(Date.parse(source));
    return source;
}

/** Parse as UTC then shift to local time */
export function parseDateAsLocal(source: string) {
    var dt = parseDateAsUTC(source);
    if (isDate(dt)) {
        dt = new Date(dt.getTime() + dt.getTimezoneOffset() * 60000);
    }
    return dt;
};

/** if val is a Date, return a date-only string e.g. '2023-12-31' */
export function toDateOnlyString(val: any) {
    // DateOnly types should not have time component, but JSON.stringify makes a full ISO string.
    // We convert it to string here to prevent that, and shift the time zone because toISOString converts to UTC.
    return val && val.getTime && new Date(val.getTime() - val.getTimezoneOffset() * 60000).toISOString().substring(0, 10) || val;
}
